var map = {
	"./shiba-body-level1.png": "abbe",
	"./shiba-body-level2.png": "4e98",
	"./shiba-body-level3.png": "5e0b",
	"./shiba-body-level4.png": "5c64",
	"./shiba-body-level5.png": "5f55",
	"./shiba-body-level6.png": "7f09"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c8bf";